<template>
  <div class="container mb-4">
    <vue-headful
      :title="
        `${
          cat[this.$route.params.cid] ? cat[this.$route.params.cid] + ' ' : ''
        }ปืน${type[this.$route.params.tid]} - Thong Firearms ร้านปืนธง`
      "
      :keywords="
        `${cat[this.$route.params.cid] ? cat[this.$route.params.cid] : ''}, ${
          type[this.$route.params.tid]
        }, Thong Firearms, ปืนธง`
      "
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <!-- <div class="max-width mt-4">
                 <img v-bind:src="'../src/assets/slide3.jpg'" alt="thong firearms">
    </div>-->
    <h2 class="mt-4 mb-4">
      <span v-if="this.$route.params.cid">{{
        cat[this.$route.params.cid]
      }}</span>
      {{ type[this.$route.params.tid] }}
    </h2>
    <div class="grid-container">
      <div
        class="spinner-grow text-danger"
        role="status"
        v-if="!arms.length && $route.params.tid < 7"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <!-- {{ $route.params.cid }}
      {{ $route.params.tid }}
      {{ filterCat }} -->
      <div
        v-if="$route.params.cid && arms != null && filtheredType.length > 0"
        class="row w-100"
      >
        <div
          v-for="arm in filtheredType"
          :key="arm.id"
          class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
        >
          <div class="item">
            <div class="img-product max-width d-flex align-items-center">
              <img v-bind:src="'/src/assets/product/' + arm.img" alt />
            </div>
            <!-- {{ type[arm.type] }} -->
            <div id="product-detail" class="mt-3">
              <h5 :title="arm.name">{{ arm.name }}</h5>
              <b-overlay
                :show="arm.inStock == 0"
                class="d-inline-block width-100"
                bg-color="white"
                opacity="0.8"
                blur="10px"
              >
                <p class="color-70">{{ arm.detail | snippet }}</p>
                <template v-slot:overlay>
                  <div class="text-center">
                    <h6 class="text-danger">OUT OF STOCK</h6>
                  </div>
                </template>
              </b-overlay>
            </div>
            <div id="read-more" class="text-center">
              <router-link v-bind:to="/product/ + arm.id" class="btn"
                >รายละเอียด</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          (arms.length != 0 && filtheredType.length == 0) ||
            $route.params.tid >= 7
        "
      >
        - ไม่พบปืนชนิดนี้ในระบบ -
      </div>
      <div v-else class="row w-100">
        <div
          v-for="arm in activeArms"
          :key="arm.id"
          class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
        >
          <div class="item">
            <div class="img-product max-width d-flex align-items-center">
              <img
                v-bind:src="'/src/assets/product/' + arm.img"
                :alt="`ปืนร้านปืนธง ${arm.name}`"
                :title="arm.name"
              />
            </div>
            <!-- {{ type[arm.type] }} -->
            <div id="product-detail" class="mt-3">
              <h5 :title="arm.name">{{ arm.name }}</h5>
              <p class="color-70">{{ arm.detail | snippet }}</p>
            </div>
            <div id="read-more" class="text-center">
              <router-link v-bind:to="/product/ + arm.id" class="btn"
                >รายละเอียด</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from "../config_db";

//import { setupFirebase } from '../config_db'
// const firebase = setupFirebase({});

// var catid = parseInt(window.location.href.split("=").pop());
// let db = firebase.database();
let armsRef = db.ref("product");
// armsRef.where({ type: Number.parseInt(this.$route.params.tid)});
// armsRef.where('name').startsWith('Be');
// armsRef.where('category').lessThan(2);

export default {
  components: {
    name: "Type"
  },
  firebase() {
    return {
      arms: armsRef
        .orderByChild("type")
        .equalTo(Number.parseInt(this.$route.params.tid))
      // armsCat : armsRef.orderByChild('category').equalTo(Number.parseInt(this.$route.params.cid))
    };
  },
  data() {
    return {
      cat: ["", "ปืนสั้น", "ปืนยาว"],
      type: [
        "",
        "กึ่งอัตโนมัติ",
        "ลูกโม่",
        "ลูกซอง",
        "ลูกเลื่อน",
        "คานเหวี่ยง",
        "ไรเฟิล"
      ],
      arms: null
    };
  },
  computed: {
    filtheredType() {
      let result = this.filterCat.filter(arm => {
        return arm.type === Number(this.$route.params.tid);
      });
      let sortBrand = result.sort((a, b) => (a.brand > b.brand ? 1 : -1));
      return sortBrand.sort((a, b) => (a.category > b.category ? 1 : -1));
    },
    filterCat() {
      let result = this.$route.params.cid
        ? this.activeArms.filter(arm => {
            return arm.category === Number(this.$route.params.cid);
          })
        : this.activeArms;
      let sortBrand = result.sort((a, b) => (a.brand > b.brand ? 1 : -1));
      return sortBrand.sort((a, b) => (a.category > b.category ? 1 : -1));
    },
    activeArms() {
      return this.arms.filter(arm => {
        return arm.show != false && arm.show != "FALSE";
      });
    }
  }
  //   created(){

  //       this.$http.get('https://thongarms-2506.firebaseio.com/product.json').then(function(data){
  //        return data.json();
  //      }).then(function(data){
  //          var dataArray = [];
  //          var brandArray = [];
  //          for(let key in data){
  //             if(key==0){

  //             }else{
  //                dataArray.push(data[key]);
  //             }
  //          }
  //         console.log(dataArray);
  //             this.arms = dataArray;
  //      });
  // 	}
};
</script>



// WEBPACK FOOTER //
// src/component/type.vue